/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Facilitator_LabelInputs */

const en_dr_room_facilitator_label = /** @type {(inputs: Dr_Room_Facilitator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Facilitator · locked until reveal`)
};

const id_dr_room_facilitator_label = /** @type {(inputs: Dr_Room_Facilitator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitator AI · terkunci sampai reveal`)
};

/**
* | output |
* | --- |
* | "AI Facilitator · locked until reveal" |
*
* @param {Dr_Room_Facilitator_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_facilitator_label = /** @type {((inputs?: Dr_Room_Facilitator_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Facilitator_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_facilitator_label(inputs)
	return en_dr_room_facilitator_label(inputs)
});